import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('.icon-carousel')]
	els.map(el => {

		const carouselEl = el.querySelector('.icon-carousel__container')
		if (!carouselEl) return null

		const iconCarousel = el.querySelector('.carousel__controls')

		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1.25,
			controls : true,
			controlsContainer: iconCarousel,
			nav: false,
			touch: true,
			mouseDrag: true,
			loop: false,
			slideBy: 1,
			responsive : {
				450 : { items : 1.25 },
				860 : { items : 1.8 },
				1150 : { items : 2.5 },
			}
		})
	})
}


